import { ComponentChildren, JSX } from 'preact';

interface SectionLabelProps {
  children: ComponentChildren;
  tone?: 'muted' | 'accent';
}

export function SectionLabel({ children, tone = 'muted' }: SectionLabelProps): JSX.Element {
  const color = tone === 'accent' ? 'var(--st-accent-calm)' : 'var(--st-text-muted)';
  return (
    <div
      style={{
        fontFamily: 'var(--st-font-body)',
        fontSize: 12,
        fontWeight: 600,
        color,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
      }}
    >
      {children}
    </div>
  );
}
